module.exports = __webpack_public_path__ + "static/media/pre-natal-peso-gestacional.692d4995.png";